import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { Spacer } from 'foundations-components/components/Spacer';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { PriceDisplay } from 'pricing-pages-ui-components/price/PriceDisplay';
import { PricePerMonth } from 'pricing-pages-ui-components/price/PricePerMonth';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PriceNumberWrapper = ({
  children
}) => /*#__PURE__*/_jsx(Text, {
  as: "span",
  typography: "heading-700",
  children: children
});
const StrikethroughListPrice = ({
  listPrice,
  currencyCode,
  showPerMonthPerSeat
}) => {
  const priceOptions = {
    price: /*#__PURE__*/_jsx(PriceDisplay, {
      price: listPrice,
      currencyCode: currencyCode,
      dataSelenium: "list-price-strikethrough"
    })
  };
  return /*#__PURE__*/_jsx(Text, {
    textDecoration: "line-through",
    typography: "heading-100",
    color: "text-core-subtle",
    paddingBlockStart: "0",
    marginBlockStart: "0",
    children: showPerMonthPerSeat ? /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "priceComponents.pricePerMonthPerSeat",
      options: priceOptions
    }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "priceComponents.pricePerMonth",
      options: priceOptions
    })
  });
};
export const PublicMerchCardPrice = ({
  monthlyPrice,
  listPrice,
  discount = 0,
  currencyCode,
  selectedTerm,
  showPerMonthPerSeat = false,
  productApiName = 'public-merch-card',
  displayName
}) => {
  const hasDiscount = discount > 0 || listPrice !== undefined && listPrice > monthlyPrice;
  const isAnnualPaymentTerm = selectedTerm === 'ANNUAL';
  const showStartsAt = hasDiscount || isAnnualPaymentTerm;
  const showStrikethrough = showStartsAt && listPrice !== undefined && listPrice > monthlyPrice;
  return /*#__PURE__*/_jsxs(View, {
    textAlign: "left",
    role: displayName ? 'region' : undefined,
    "aria-label": displayName ? unescapedText('priceComponents.pricingLabel', {
      name: displayName
    }) : undefined,
    children: [showStartsAt ? /*#__PURE__*/_jsx(Text, {
      as: "small",
      typography: "detail-200",
      color: "text-core-subtle",
      "data-test-id": "starts-at",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "priceComponents.subtexts.startsAt"
      })
    }) : /*#__PURE__*/_jsx(Spacer, {
      space: "600"
    }), /*#__PURE__*/_jsx(Text, {
      as: "div",
      typography: "heading-400",
      "data-style": "line-height-xs",
      children: /*#__PURE__*/_jsx(PricePerMonth, {
        price: monthlyPrice,
        showPricePerMonthPerSeat: showPerMonthPerSeat,
        seleniumId: productApiName,
        currencyCode: currencyCode,
        PriceWrapper: PriceNumberWrapper
      })
    }), showStrikethrough && /*#__PURE__*/_jsx(StrikethroughListPrice, {
      listPrice: listPrice,
      currencyCode: currencyCode,
      showPerMonthPerSeat: showPerMonthPerSeat
    })]
  });
};